/* eslint-disable */
import React, { useEffect, useState } from "react";
import { IAutocompleteHit } from "../../api/searchApi.types";
import { updateAutocomplete, useAutocomplete } from "../../redux/autocomplete";
import { ISearchBarProps } from "./searchBar.types";

const SearchBar: React.FC<ISearchBarProps> = ({
  clearText,
  defaultSearchTerm,
  disableAutocomplete = false,
  hideSearchBarContainer,
  onClear,
  onSubmit,
  searchPlaceholder,
  searchReload = false,
  showCloseButton,
  submitText,
}) => {
  const [searchTerm, setSearchTerm] = useState<string>(defaultSearchTerm);
  const [showAutocompleteResults, setShowAutocompleteResults] =
    useState<boolean>(false);
  const autocompleteResults = useAutocomplete();
  const [activeAutocompleteIndex, setActiveAutocompleteIndex] =
    useState<number>(-1);

  const onClearClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    clearInput();
    e.preventDefault();
    e.stopPropagation();
    onClear && onClear();
  };

  const clearInput = () => {
    setSearchTerm("");
    setShowAutocompleteResults(false);
    setActiveAutocompleteIndex(-1);
  };

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    setSearchTerm(value);

    if (value.length > 2 && !disableAutocomplete) {
      updateAutocomplete(e.currentTarget.value).then((x) => {
        if (autocompleteResults.hits.length > 0)
          setShowAutocompleteResults(true);
        else setShowAutocompleteResults(false);
      });
    } else {
      setShowAutocompleteResults(false);
    }
  };

  const onAutocompleteClick = (value: string) => {
    setSearchTerm(value);
    onSubmit(value);
    setShowAutocompleteResults(false);
  };

  const onSubmitClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onSubmit(searchTerm);
    setShowAutocompleteResults(false);
    e.preventDefault();
    e.stopPropagation();
  };

  const onCloseClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    clearInput();
    e.preventDefault();
    e.stopPropagation();
  };

  const onSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onSubmit(searchTerm);
      setShowAutocompleteResults(false);
      e.preventDefault();
      e.stopPropagation();
    }
  };

  useEffect(() => {
    clearInput();
  }, [searchReload]);

  return (
    <>
      <div
        className={
          !hideSearchBarContainer
            ? "searchbar-container w-100 sticky-searchbar"
            : ""
        }
      >
        <div className="wrapper-1180">
          <div className="m-0 row">
            <div className="col-12 p-0">
              <form className="searchbar-form">
                <input
                  type="text"
                  className="searchbar-input"
                  data-searchbar-input="searchbar-input"
                  placeholder={searchPlaceholder}
                  title="searchbar"
                  onKeyDown={onSearchKeyDown}
                  onChange={onInputChange}
                  value={searchTerm}
                />
                {searchTerm.length > 0 && (
                  <a
                    className="searchbar-clear-button text-underline"
                    onClick={onClearClick}
                    role="button"
                  >
                    {clearText}
                  </a>
                )}

                <button
                  className="d-md-block searchbar-submit-button"
                  onClick={onSubmitClick}
                >
                  {submitText}
                </button>

                {showCloseButton && (
                  <button
                    className="d-md-block searchbar-close-button svg__span--close"
                    data-search-close
                    onClick={onCloseClick}
                  ></button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          !hideSearchBarContainer ? "searchbar-dropdown-container w-100" : ""
        }
      >
        <div className="wrapper-1180">
          <div className="col-12 p-0">
            {!disableAutocomplete && showAutocompleteResults ? (
              <ul className="searchbar-ul">
                {autocompleteResults.hits.map((x: IAutocompleteHit) => (
                  <li className="searchbar-li" data-searchbar-li="searchbar-li">
                    <a
                      className="d-block searchbar-link"
                      data-searchbar-link="searchbar-link"
                      onClick={() => onAutocompleteClick(x.query)}
                    >
                      {x.query}
                    </a>
                  </li>
                ))}
              </ul>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchBar;
